import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Hint from '~/Common-Objects/UI/Hint/Hint'
import Icons from '~/Common-Objects/UI/Icons/index'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import WarningHolder from '~/Common-Objects/UI/Cards/WarningHolder'
import axios from '../../../../data/http/axios'
import helpers from '../../../../Classes/helpers'
import { alterSiteDrawer } from '../../../../data/actions/siteActions'

const options = [
    {
        label: 'Active',
        value: 'active'
    },
    {
        label: 'In-Active',
        value: 'inactive'
    }
]

export default function GroupAutomate({ GroupId, groupName }) {
    const site = useSelector((state) => state.siteMaster)
    const history = useHistory()
    const dispatch = useDispatch()
    const [trigger, setTrigger] = useState('')
    const [name, setName] = useState(groupName + ' Automation')

    const create = async () => {
        const res = await axios.post('/automation', {
            name,
            version: 1,
            status: 'Draft',
            steps: [
                {
                    guid: helpers.createLocalGuid(),
                    type: 'initial',
                    complete: true,
                    parentGuid: 0,
                    stepOptions: {
                        groupId: { value: GroupId, required: true },
                        subscriberState: { value: trigger }
                    },
                    triggerType: { value: '0', required: true },
                    wizardComplete: true
                }
            ],
            options: {
                source: 'Group Subscribers'
            }
        })
        history.push('/cp/automation/addnew/' + res.data.Automation.id + '?redirect=/cp/groups/' + GroupId)
        dispatch(alterSiteDrawer(false, true, 'right', null))
    }

    return (
        <div>
            <div className='quickFlex mar-b10' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <h4>Create an new Automation</h4>
                {site.siteId === 1 && (
                    <Hint
                        href='https://transpond.io/support/automating-your-communications/transpond-automations'
                        iconLeft={
                            <Icons icon='questionCircle' color='#2B2F41' style={{ height: 16, width: 16 }} />
                        }
                    >
                        Learn More
                    </Hint>
                )}
            </div>

            <p className='mar-b25 text-sml'>
                You can start a new automation based on when contacts join this group. <br />
                <br />
                Then perform lots of actions such as automatically sending the contact to a chain of emails.
            </p>

            <Select
                outerClassName='mar-b25'
                label='Should active or inactive contacts enter this automation?'
                data={options}
                value={trigger}
                onChange={(e) => setTrigger(e.target.value)}
            />

            {!!trigger && (
                <TextInput
                    label='Give this new Automation a name'
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    outerClassName='mar-b25'
                />
            )}

            {!!trigger && !!name && (
                <>
                    <WarningHolder className='mar-b25'>
                        This will create the automation and take you to the automation designer so you can setup any
                        actions you want to happen when this automation is triggered
                    </WarningHolder>
                    <Button className='button-primary' onClick={create}>
                        Create Automation
                    </Button>
                </>
            )}
        </div>
    )
}
